import React, { useContext, useState, useEffect } from 'react';
import {
    Row,
    Col,
} from 'react-bootstrap';
import { useForm } from "react-hook-form";
import notification from '../../components/notification.component';
import { ConfigContextUtils } from '../../context/contextUtils.context';
import functions from './productos.functions';
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import * as table from './productos.table';
import Card from '../../components/card.component';

const ProductosComponent = () => {

    const { setPreloader } = useContext(ConfigContextUtils);
    const { register, handleSubmit, reset, errors } = useForm();
    const [data, setData] = useState([]);
    const [incmod, setIncMod] = useState('I');

    const onSubmit = (data) => {
        setPreloader(true);
        if (incmod === 'I') {
            functions.register(data).then((response) => {
                if (response.error) {
                    notification.warning();
                    setPreloader(false);
                } else {
                    obtenerProductos();
                    notification.success();
                    reset({});
                }
            });
        } else {
            functions.update(data).then((response) => {
                if (response.error) {
                    notification.warning();
                    setPreloader(false);
                } else {
                    obtenerProductos();
                    notification.success();
                    setIncMod('I');
                    reset({});
                }
            });
        }
    }

    useEffect(() => {
        obtenerProductos();
        // eslint-disable-next-line 
    },[]);

    const obtenerProductos = () => {
        setPreloader(true);
        functions.listado().then((response) => {
            if (!response.error) {
                let productos = [];
                response.productos.forEach(item => {
                    if (!item.is_guide) {
                        productos.push(item);
                    }
                });
                setData(productos);
            }
            setPreloader(false);
        })
    }

    const edition = (row) => {
        reset(row);
        setIncMod('M');
    }

    const clean = () => {
        reset({});
        setIncMod('I');
    }

    const lock = (row) => {
        functions.update({ ...row, estado: row.estado ? 0 : 1 }).then((response) => {
            if (response.error) {
                notification.warning();
                setPreloader(false);
            } else {
                obtenerProductos();
                notification.success();
                setIncMod('I');
                reset({});
            }
        });
    }

    return (
        <>
        <form onSubmit={handleSubmit(onSubmit)}>
        <Card>
            <Row>
            <Col>
                <div className="grupo-input">
                <small>Nombre del producto</small>
                <input type="text" className={`form-control input-border ${errors.nombre_producto && "is-invalid"}`} name="nombre_producto" ref={register({ required: true })} />
                </div>
            </Col>
            <Col>
                <div className="grupo-input">
                <small>Precio Unitario</small>
                <input type="text" className={`form-control input-border ${errors.costo && "is-invalid"}`} name="costo" ref={register({ required: true })} />
                </div>
            </Col>
            </Row>
            <Row className="mt-2">
                <Col className="d-flex justify-content-end">
                    <input type="hidden" name="visible_web" value="false" ref={register({ required: true })}/>
                    <input type="hidden" name="id" value="false" ref={register({ required: false })}/>
                    <button type="submit" className="btnx btnx-warn mr-2">{incmod === 'I' ? 'Registrar' : 'Modificar'}</button> 
                    <button type="button" onClick={clean} className="btnx btnx-warn">Cancelar</button> 
                </Col>
            </Row>
        </Card>
        </form>
        <Card className="mt-2">
            <Row>
                <Col>
                    <DataTableExtensions
                        columns={table.productos(edition, lock)}
                        data={data}
                        export={false}
                        print={false}
                        filterPlaceholder="Buscar producto"
                    >
                        <DataTable
                            noHeader={true}
                            customStyles={table.customStyles}
                            dense={true}
                            noDataComponent={'No existen productos asociados'}
                        />
                    </DataTableExtensions>
                </Col>
            </Row>
        </Card>
       </>
    )
}


export default ProductosComponent;